/*
 * https://yhashimoto.com
 * Copyright Yohei Hashimoto */
import $ from 'jquery';
 
$(() => {
    const $sortUl = $('.-js-sort-ul');
    const baselist = $sortUl.find('li').get(); // 初期状態のリストを取得
    const $dateList = $('#dateList');

    // 並び替え関数
    function sortList(order) {
        $('.-js-sort').removeClass('-active');
        const items = $sortUl.find('li').get(); // li要素を配列に変換
        items.sort((a, b) => {
            const dateA = new Date($(a).data('date'));
            const dateB = new Date($(b).data('date'));
            return order === 'new' ? dateB - dateA : dateA - dateB; // 新しい順または古い順
        });
        $.each(items, function(_, item) {
            $dateList.append(item); // 並び替えたリストを再追加
        });
    }

    // リストをリセットする関数
    function resetList() {
        $('.-js-sort').removeClass('-active');
        $.each(baselist, function(_, item) {
            $dateList.append(item); // 初期状態のリストを再追加
        });
    }

    // イベントリスナー
    $('.-js-sort-reset').on('click', function() {
        resetList();
        $(this).addClass('-active');
    });

    $('.-js-sort-new').on('click', function() {
        sortList('new'); // 新しい順
        $(this).addClass('-active');
    });

    $('.-js-sort-old').on('click', function() {
        sortList('old'); // 古い順
        $(this).addClass('-active');
    });
});